import { Billboard, Html } from "@react-three/drei"
import { useStore } from "@state/store"
import styled from "styled-components"
import { Vector3 } from "three"
import { BEDKEY } from "@common/components/ResidenceGeneric/ResidenceInfoCard"
import { poundFormatter } from "@utils/functions"

const UnitLabel = (props) => {
  const { data, center } = props
  // const { nodes: model } = useGLTF(
  //   "/assets/models/vivid_reality_logo_3d_model/scene.glb",
  // ) as any;
  const syncState = useStore((s) => s.syncState)

  const handleClick = () => {
    syncState({ controlsVisible: false, residencePopup: true })
  }

  return (
    <group
      onClick={handleClick}
      position={new Vector3(center.x, center.y + 0.13, center.z)}
    >
      <Billboard lockX={true} lockY={false} lockZ={false}>
        <group position={[0, 0, 0]}>
          <Html
            // position={[0.05, 0, 0]}
            color="white"
            center={true}
          >
            <SelectedUnitContainer
              style={{
                // transform: "translate(calc(100% + 4rem), -100%)",
                transform: "translate(50%, -110%)",
                width: "20rem",
              }}
            >
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  paddingBottom: "1rem",
                }}
              >
                <h1
                  style={{
                    fontSize: "2.5rem",

                    color: "#fff",
                  }}
                >
                  {data.id}
                </h1>

                {
                  <img
                    onClick={handleClick}
                    style={{
                      cursor: "pointer",
                      filter: "invert(1)",
                      transform: "rotate(90deg)",
                      height: "3.2rem",
                    }}
                    src="/assets/icons/right-arrow.svg"
                  />
                }
              </div>

              <InfoRow>
                <span>Price:</span>
                <span>{poundFormatter.format(data.price)}</span>
              </InfoRow>
              <InfoRow>
                <span>Beds:</span>
                <span>{BEDKEY[data.beds]}</span>
              </InfoRow>
              {data.typology === "Apartment" && (
                <InfoRow>
                  <span>Floor:</span>
                  <span>{data.floor === "0" ? "GF" : data.floor}</span>
                </InfoRow>
              )}

              <InfoRow>
                <span>Availability:</span>
                <span>{data.status}</span>
              </InfoRow>
            </SelectedUnitContainer>
          </Html>
        </group>

        {/* <mesh
          renderOrder={2}
          scale={0.1}
          onPointerOver={() => (document.body.style.cursor = "pointer")}
          onPointerOut={() => (document.body.style.cursor = "auto")}
          geometry={model["mesh_0"].geometry}
        >
          <meshMatcapMaterial
            depthTest={false}
            opacity={1}
            transparent
            toneMapped={false}
            color={"#174037"}
          />
        </mesh>
        <mesh renderOrder={3} scale={0.1} geometry={model["mesh_1"].geometry}>
          <meshMatcapMaterial
            depthTest={false}
            depthWrite={false}
            opacity={1}
            transparent
            toneMapped={false}
            color={"#fff"}
          />
        </mesh> */}
      </Billboard>
    </group>
  )
}

export default UnitLabel

const SelectedUnitContainer = styled.div`
  position: absolute;
  top: 0%;
  right: 0;
  /* margin: 2rem; */
  padding: 1rem 1.5rem;
  width: 100%;
  z-index: 1000;
  color: white;
  font-size: 1.5rem;
  font-weight: 600;
  /* background-color: rgba(0, 0, 0, 0.); */
  background-color: #0a2620f9;
  border: 1px solid white;
  border-radius: 8px;
  line-height: 1.4;

  backdrop-filter: blur(3px);
`

// Styled component for individual information rows
const InfoRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 0.5rem;

  & span:nth-of-type(2) {
    font-family: Thirdfont;
  }

  &:last-child {
    margin-bottom: 0; // Remove margin for the last item
  }
`
